<div class="hover-controlled sam-full-width sam-ellipsis-on-overflow sam-margin-left-medium">
   <span *ngIf="ShowPrimaryFullDateFormat; else showTimeAgoOnNoneHover">
      <span class="show-only-on-none-hover">
         {{ CallTimestamp | toUTCMoment$ | async | amLocal | amDateFormat: 'LL' }}
         <span [ngClass]="ConversationStatus.styleClass" class="sam-call-history-time">
            {{ CallTimestamp | toUTCMoment$ | async | amLocal | amDateFormat: 'LT' }}</span
         >
      </span>
      <span class="show-on-hover">
         {{ CallTimestamp | toUTCMoment$ | async | amLocal | amTimeAgo }}
      </span>
   </span>
</div>
<ng-template #showTimeAgoOnNoneHover>
   <div class="hover-controlled sam-full-width sam-ellipsis-on-overflow sam-margin-left-medium">
      <span>
         <span class="show-only-on-none-hover">
            {{ CallTimestamp | toUTCMoment$ | async | amLocal | amTimeAgo }}
         </span>
         <span class="show-on-hover">
            {{ CallTimestamp | toUTCMoment$ | async | amLocal | amDateFormat: 'LL' }}
            <span [ngClass]="ConversationStatus.styleClass" class="sam-call-history-time">{{
               CallTimestamp | toUTCMoment$ | async | amLocal | amDateFormat: 'LT'
            }}</span>
         </span>
      </span>
   </div>
</ng-template>
